<template>
    <div class="bg-white mb-4 rounded shadow-sm">
        <div @click="toggleItem" class="cursor-pointer flex font-medium items-center px-2 py-3 text-base">
            <div>
                <svg :class="{ 'rotate-180': item.open, 'rotate-0': !item.open }" class="h-5 mr-2 transform w-5" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
            </div>
            <div class="flex-grow select-none" v-html="item.question"></div>
        </div>
        <div v-if="item.open" class="leading-relaxed pb-3 px-4 text-gray-600 text-justify text-sm" v-html="item.answer"></div>
    </div>
</template>

<script>
export default {
    props: {
        index: {
            type: Number,
            required: true,
        },
        item: {
            type: Object,
            required: true,
        },
    },

    methods: {
        toggleItem() {
            Bus.$emit('toggleFaqItem', { index: this.index });
        },
    },
};
</script>
